//natives
import React, { Component } from 'react';

//components
import CotacoesLista from '../childrens/cotacoesLista/.mixins/CotacoesLista';
import Alerta from "../../../../../util/snackbars/.mixins/";

export default class Cotacoes extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: 'Cotações',
        }
    }

    render() {
        return (
            <div className={'container'}>
                <CotacoesLista {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}